import { Button, Input, Modal, Select } from "antd";
import { useEffect, useState } from "react";
import axiosInstance from "../common/api";
import { filterOption } from "../common/common";

export default function ({ quantity, product, reason, value, onChange }) {
  const [open, setOpen] = useState(false);
  const [internalValue, setInternalValue] = useState([]);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (product && reason) {
      axiosInstance
        .get("dpiInventoryUnit", {
          params: {
            dpiProduct: product,
            status: reason.inventoryTransactionSign > 0 ? "NOT_AVAILABLE" : "AVAILABLE",
            pageSize: 999999,
          },
        })
        .then(({ data }) =>
          setOptions(data.data.map((x) => ({ label: x.serialNumber, value: x.id }))),
        );
    }
  }, [product,reason]);

  useEffect(() => {
    const nv = Array(quantity ?? 0).fill(null);
    setInternalValue(nv);
    onChange(nv);
  }, [quantity]);

  useEffect(() => {
    setInternalValue(value);
  }, [open, value]);

  return (
    <div>
      {quantity > 0 && (
        <Button type="link" onClick={() => setOpen(true)}>
          Seleziona matricole
        </Button>
      )}
      <Modal
        title="Seleziona matricole"
        open={open}
        onCancel={() => setOpen(false)}
        onOk={() => {
          onChange(internalValue);
          setOpen(false);
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", rowGap: 6 }}>
          {(internalValue ?? []).map((item, index) => (
            <Select
              options={options}
              filterOption={filterOption}
              value={item}
              onChange={(val) =>
                setInternalValue(internalValue.map((x, i) => (index === i ? val : x)))
              }
              showSearch
            />
          ))}
        </div>
      </Modal>
    </div>
  );
}
